package com.evoapps.evoshift.ui.roster

import com.evoapps.evoshift.ui.calendar.CalendarFocusRing
import com.evoapps.evoshift.ui.calendar.monthCalendarDay
import com.evoapps.evoshift.ui.calendar.monthCalendarKeys
import com.evoapps.evoshift.ui.calendar.rememberMonthCalendarState
import com.evoapps.evoshift.domain.util.calculateDurationMinutes
import com.evoapps.evoshift.ui.util.durationText
import com.evoapps.evoshift.ui.util.monthInSentence
import androidx.compose.foundation.layout.heightIn

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.MessageEffect
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import evoshift.composeapp.generated.resources.skeleton_finish
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.viewmodels.Gate
import evoshift.composeapp.generated.resources.time_same_start_end
import evoshift.composeapp.generated.resources.skeleton_template_name_required
import evoshift.composeapp.generated.resources.skeleton_custom_shift_subtitle
import evoshift.composeapp.generated.resources.back
import com.evoapps.evoshift.widgets.parseClockTime
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.RoleField
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoListRow
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.DialogAction
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.filled.ViewDay
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Add
import androidx.compose.animation.AnimatedVisibility
import evoshift.composeapp.generated.resources.template_shift_count
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.ui.util.dayShort
import evoshift.composeapp.generated.resources.roster_add_custom_shift
import evoshift.composeapp.generated.resources.roster_role_optional
import evoshift.composeapp.generated.resources.roster_save_as_template
import evoshift.composeapp.generated.resources.template_name
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.gestures.Orientation
import androidx.compose.foundation.gestures.scrollable
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.style.TextAlign
import com.evoapps.evoshift.ui.adaptive.CentredBox
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import androidx.compose.foundation.layout.RowScope
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.isoDayNumber
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.DayTemplate
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.RosterSkeletonEvent
import com.evoapps.evoshift.viewmodels.SkeletonFinishStep
import com.evoapps.evoshift.domain.usecase.finance.RevenuePlan
import com.evoapps.evoshift.ui.finance.formatMoney
import evoshift.composeapp.generated.resources.skeleton_done_availability_intro
import evoshift.composeapp.generated.resources.skeleton_done_continue
import evoshift.composeapp.generated.resources.skeleton_done_later
import evoshift.composeapp.generated.resources.skeleton_done_revenue_days
import evoshift.composeapp.generated.resources.skeleton_done_revenue_fixed
import evoshift.composeapp.generated.resources.skeleton_done_revenue_intro
import evoshift.composeapp.generated.resources.skeleton_done_revenue_none
import evoshift.composeapp.generated.resources.skeleton_done_revenue_title
import evoshift.composeapp.generated.resources.skeleton_done_revenue_total
import evoshift.composeapp.generated.resources.skeleton_done_revenue_weekday
import com.evoapps.evoshift.viewmodels.RosterSkeletonViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.roster_add_manual_slot
import evoshift.composeapp.generated.resources.skeleton_fill
import evoshift.composeapp.generated.resources.skeleton_fill_days
import evoshift.composeapp.generated.resources.skeleton_fill_days_text
import com.evoapps.evoshift.domain.capacity.monthRange
import androidx.compose.material.icons.filled.DateRange
import evoshift.composeapp.generated.resources.roster_add_shift_template
import evoshift.composeapp.generated.resources.roster_apply_day_template
import evoshift.composeapp.generated.resources.roster_builder_title
import evoshift.composeapp.generated.resources.roster_no_day_templates
import evoshift.composeapp.generated.resources.roster_start_time
import evoshift.composeapp.generated.resources.roster_end_time
import evoshift.composeapp.generated.resources.save
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalTime
import kotlinx.datetime.Month
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.plus
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.domain.util.AppClock.now

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RosterSkeletonScreen(
    viewModel: RosterSkeletonViewModel,
    onNavigateBack: () -> Unit,
    onFinished: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }

    // Fix: Replaced deprecated todayIn
    val today = remember { now().toLocalDateTime(TimeZone.currentSystemDefault()).date }
    var selectedDate by remember { mutableStateOf(today) }

    var showAddDialog by remember { mutableStateOf(false) }
    var showTemplateDialog by remember { mutableStateOf(false) }
    var showFillDays by remember { mutableStateOf(false) }

    MessageEffect(state.message, snackbarHostState, onShown = { viewModel.onEvent(RosterSkeletonEvent.MessageShown) })
    // SH-188: cleared once shown, so the same failure twice in a row is reported twice.
    MessageEffect(state.error, snackbarHostState, onShown = { viewModel.onEvent(RosterSkeletonEvent.DismissError) })

    LaunchedEffect(state.success) {
        if (state.success) {
            onFinished()
        }
    }

    LaunchedEffect(state.roster) {
        state.roster?.let { roster ->
            if (selectedDate.month.number != roster.month || selectedDate.year != roster.year) {
                selectedDate = LocalDate(roster.year, roster.month, 1)
            }
        }
    }

    // The skeleton is finished (SH-69): the month's sales plan, then the availability request.
    when (val step = state.finishStep) {
        is SkeletonFinishStep.RevenuePlanSummary -> RevenuePlanDialog(
            plan = step.plan,
            currency = state.currency,
            monthLabel = state.roster?.let { "${monthName(it.month)} ${it.year}" }.orEmpty(),
            onContinue = { viewModel.onEvent(RosterSkeletonEvent.RevenuePlanSeen) }
        )
        SkeletonFinishStep.AvailabilityRequest -> state.roster?.let { roster ->
            AvailabilityRequestDialog(
                roster = roster,
                onDismiss = { viewModel.onEvent(RosterSkeletonEvent.SkipAvailabilityRequest) },
                onConfirm = { start, end, due, message, emailLinks ->
                    viewModel.onEvent(RosterSkeletonEvent.SendAvailabilityRequest(start, end, due, message, emailLinks))
                },
                intro = stringResource(Res.string.skeleton_done_availability_intro, "${monthInSentence(roster.month)} ${roster.year}"),
                dismissLabel = stringResource(Res.string.skeleton_done_later),
                isSending = state.isSendingRequest
            )
        }
        null -> Unit
    }

    val isExpanded = LocalWindowWidthClass.current.isExpanded
    // Read-only once the workplace's plan ended (SH-65): the month to see, nothing to shape.
    val canEdit = state.capabilities.shows(Gate.ROSTER_EDITING)
    val actionButtons: @Composable RowScope.() -> Unit = {
    if (canEdit) Box(
        modifier = Modifier
            .weight(1f)
            .height(48.dp)
            .clip(RoundedCornerShape(8.dp))
            .background(GoldMetallicBrush)
            .handCursor()
            .clickable { showAddDialog = true },
        contentAlignment = Alignment.Center
    ) {
        Text(
            stringResource(Res.string.roster_add_manual_slot),
            color = DeepNavy,
            fontWeight = FontWeight.Bold,
            style = MaterialTheme.typography.labelMedium,
            textAlign = TextAlign.Center,
            maxLines = 2,
            modifier = Modifier.padding(horizontal = 8.dp)
        )
    }

    if (canEdit) Box(
        modifier = Modifier
            .weight(1f)
            .height(48.dp)
            .clip(RoundedCornerShape(8.dp))
            .background(DeepNavy)
            .handCursor()
            .clickable { showTemplateDialog = true },
        contentAlignment = Alignment.Center
    ) {
        Text(
            stringResource(Res.string.roster_apply_day_template),
            color = Color.White,
            fontWeight = FontWeight.Bold,
            style = MaterialTheme.typography.labelMedium,
            textAlign = TextAlign.Center,
            maxLines = 2,
            modifier = Modifier.padding(horizontal = 8.dp)
        )
    }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Color.White,
        topBar = {
            EvoTopBar(
                // SH-89: the workplace and the month are the bar's (App.kt follows the month).
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    add(helpAction(HelpPage.ROSTER_SKELETON))
                    // SH-48: the weekly skeleton for a range of days (those without shifts yet).
                    if (canEdit && state.roster != null) {
                        add(TopBarAction(stringResource(Res.string.skeleton_fill_days), Icons.Default.DateRange, { showFillDays = true }, enabled = !state.isFilling, busy = state.isFilling))
                    }
                    if (canEdit) {
                        add(
                            TopBarAction(
                                stringResource(Res.string.skeleton_finish), Icons.Default.Check,
                                { viewModel.onEvent(RosterSkeletonEvent.FinalizeSkeleton) },
                                enabled = !state.isSaving, prominent = true, iconOnCompact = true, busy = state.isSaving
                            )
                        )
                    }
                }
            )
        },
        bottomBar = {
            // Wide windows show the actions under the month instead.
            if (!isExpanded && canEdit) Column(modifier = Modifier.background(Color.White)) {
                // Progress Line from design
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 24.dp, vertical = 8.dp)
                        .height(4.dp)
                        .clip(CircleShape)
                        .background(Color.LightGray.copy(alpha = 0.3f))
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth(0.6f)
                            .fillMaxHeight()
                            .background(DeepNavy)
                    )
                }

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(16.dp)
                        .padding(bottom = 8.dp),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    actionButtons()
                }
            }
        }
    ) { padding ->
        val roster = state.roster
        if (isExpanded && roster != null) {
            // Wide windows: the whole month and the actions on the left, the day's timeline on
            // the right, instead of a date strip over a full-width timeline.
            // SH-130: the month's column reaches the left edge, so the wheel scrolls it over the
            // empty side too; the timeline's own frame stays within the centred width.
            CentredBox(WideContentMaxWidth, Modifier.padding(padding)) { margin ->
            // SH-136: the timeline's frame stays in the centred width; the wheel over the empty
            // right side scrolls the timeline too (the same scroll state, beside the frame).
            val timelineScroll = rememberScrollState()
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(vertical = 24.dp),
                horizontalArrangement = Arrangement.spacedBy(24.dp)
            ) {
                Column(
                    modifier = Modifier.width(360.dp + margin + 24.dp).fillMaxHeight().verticalScroll(rememberScrollState()).padding(start = margin + 24.dp),
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    MonthDatePicker(
                        year = roster.year,
                        month = roster.month,
                        firstDayOfWeek = state.firstDayOfWeek,
                        selectedDate = selectedDate,
                        hasShifts = { !state.shiftsByDate[it].isNullOrEmpty() },
                        onSelect = { selectedDate = it }
                    )
                    Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) { actionButtons() }
                    // SH-172: the day's answers beside the month, the people listed at once.
                    state.dayAnswers(selectedDate)?.let { DayAnswersPanel(it, expanded = true) }
                }
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                        .clip(RoundedCornerShape(20.dp))
                        .border(1.dp, DeepNavy.copy(alpha = 0.1f), RoundedCornerShape(20.dp))
                        .background(Color.White)
                        .padding(vertical = 8.dp)
                ) {
                    if (state.isLoading && state.shiftsByDate.isEmpty()) {
                        CircularProgressIndicator(
                            modifier = Modifier.align(Alignment.Center),
                            color = DarkGold
                        )
                    } else {
                        val shifts = state.shiftsByDate[selectedDate] ?: emptyList()
                        RosterBuilderTimeline(
                            shifts = shifts,
                            onDeleteShift = { id: String -> viewModel.onEvent(RosterSkeletonEvent.DeleteShift(id)) }.takeIf { canEdit },
                            scrollState = timelineScroll
                        )
                    }
                }
                Box(
                    Modifier
                        .width(margin)
                        .fillMaxHeight()
                        .testTag(SkeletonTags.TIMELINE_MARGIN)
                        // Reversed like verticalScroll's own scrollable, so the wheel scrolls the same way.
                        .scrollable(timelineScroll, Orientation.Vertical, reverseDirection = true)
                )
            }
            }
        } else {
            Column(
                modifier = Modifier
                    .padding(padding)
                    .fillMaxSize()
            ) {
                if (roster != null) {
                    val daysInMonth = remember(roster) { getDaysInMonth(roster.year, roster.month) }

                    // --- Horizontal Date Strip ---
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(Color(0xFFF7F2E9))
                            .padding(vertical = 12.dp)
                    ) {
                        val listState = rememberLazyListState()
                        // Keep the selected day in view (it starts on today, often off-screen on phones).
                        LaunchedEffect(selectedDate, daysInMonth) {
                            val index = daysInMonth.indexOf(selectedDate)
                            if (index >= 0) listState.animateScrollToItem((index - 2).coerceAtLeast(0))
                        }
                        LazyRow(
                            modifier = Modifier.fillMaxWidth(),
                            contentPadding = PaddingValues(horizontal = 16.dp),
                            horizontalArrangement = Arrangement.spacedBy(20.dp),
                            state = listState
                        ) {
                            items(daysInMonth) { date ->
                                DateItem(
                                    date = date,
                                    isSelected = date == selectedDate,
                                    onClick = { selectedDate = date }
                                )
                            }
                        }
                    }

                    // SH-172: the day's answers over its timeline; the people unfold on a tap.
                    state.dayAnswers(selectedDate)?.let { answers ->
                        Box(
                            Modifier
                                .fillMaxWidth()
                                .heightIn(max = 420.dp)
                                .verticalScroll(rememberScrollState())
                                .padding(horizontal = 16.dp, vertical = 8.dp)
                        ) {
                            DayAnswersPanel(answers)
                        }
                    }

                    // --- Timeline View ---
                    Box(modifier = Modifier.weight(1f).background(Color.White)) {
                        if (state.isLoading && state.shiftsByDate.isEmpty()) {
                            CircularProgressIndicator(
                                modifier = Modifier.align(Alignment.Center),
                                color = DarkGold
                            )
                        } else {
                            val shifts = state.shiftsByDate[selectedDate] ?: emptyList()
                            RosterBuilderTimeline(
                                shifts = shifts,
                                onDeleteShift = { id: String -> viewModel.onEvent(RosterSkeletonEvent.DeleteShift(id)) }.takeIf { canEdit }
                            )
                        }
                    }
                } else if (state.isLoading) {
                    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        CircularProgressIndicator(color = DarkGold)
                    }
                }
            }
        }
    }

    if (showAddDialog) {
        AddShiftFromTemplateDialog(
            templates = state.availableShiftTemplates,
            availableRoles = state.availableRoles,
            onDismiss = { showAddDialog = false },
            onSelect = { template ->
                viewModel.onEvent(RosterSkeletonEvent.AddShiftFromTemplate(selectedDate, template))
                showAddDialog = false
            },
            onCustomShift = { start, end, role, save, name ->
                viewModel.onEvent(
                    RosterSkeletonEvent.AddCustomShift(
                        selectedDate,
                        start,
                        end,
                        role,
                        save,
                        name
                    )
                )
                showAddDialog = false
            }
        )
    }

    val roster = state.roster
    if (showFillDays && roster != null) {
        DayRangeDialog(
            title = stringResource(Res.string.skeleton_fill_days),
            year = roster.year,
            month = roster.month,
            initial = monthRange(roster.year, roster.month),
            text = stringResource(Res.string.skeleton_fill_days_text),
            confirmLabel = stringResource(Res.string.skeleton_fill),
            onConfirm = {
                viewModel.onEvent(RosterSkeletonEvent.FillDays(it))
                showFillDays = false
            },
            onDismiss = { showFillDays = false }
        )
    }

    if (showTemplateDialog) {
        SelectDayTemplateDialog(
            templates = state.availableDayTemplates,
            onDismiss = { showTemplateDialog = false },
            onSelect = { template ->
                viewModel.onEvent(RosterSkeletonEvent.ApplyDayTemplate(selectedDate, template))
                showTemplateDialog = false
            }
        )
    }
}

@Composable
fun DateItem(
    date: LocalDate,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.handCursor().clickable(onClick = onClick)
    ) {
        Text(
            text = dayShort(date.dayOfWeek),
            style = MaterialTheme.typography.labelSmall,
            color = if (isSelected) DeepNavy else Color.Gray,
            fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal
        )
        Spacer(Modifier.height(4.dp))
        Box(
            modifier = Modifier
                .size(32.dp)
                .clip(CircleShape)
                .background(if (isSelected) DeepNavy else Color.Transparent),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = date.day.toString(),
                style = MaterialTheme.typography.bodyMedium,
                color = if (isSelected) Color.White else DeepNavy,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

/**
 * The roster's month as a calendar for wide windows, where a horizontal strip would leave most
 * of the screen empty. Days that already have shifts carry a gold dot.
 */
@Composable
private fun MonthDatePicker(
    year: Int,
    month: Int,
    firstDayOfWeek: Int,
    selectedDate: LocalDate,
    hasShifts: (LocalDate) -> Boolean,
    onSelect: (LocalDate) -> Unit
) {
    val days = remember(year, month) { getDaysInMonth(year, month) }
    val dayOrder = (0..6).map { (it + firstDayOfWeek - 1) % 7 + 1 }
    val offset = days.firstOrNull()?.let { (it.dayOfWeek.isoDayNumber - firstDayOfWeek + 7) % 7 } ?: 0
    val cells: List<LocalDate?> = List(offset) { null } + days
    // SH-161: one focus stop; the arrows move the ring, Enter picks the day.
    val keyboard = rememberMonthCalendarState()
    val pick: (LocalDate) -> Unit = { date ->
        keyboard.cursor = date
        onSelect(date)
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(20.dp))
            .background(Color(0xFFF7F2E9))
            .monthCalendarKeys(keyboard, days, firstDayOfWeek, selectedDate, onOpen = pick)
            .padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            "${monthName(month)} $year",
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold,
            color = DeepNavy,
            modifier = Modifier.padding(bottom = 4.dp)
        )
        Row(Modifier.fillMaxWidth()) {
            dayOrder.forEach { isoDay ->
                Text(
                    dayShort(DayOfWeek(isoDay)),
                    style = MaterialTheme.typography.labelSmall,
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.weight(1f)
                )
            }
        }
        cells.chunked(7).forEach { week ->
            Row(Modifier.fillMaxWidth()) {
                (0 until 7).forEach { index ->
                    val date = week.getOrNull(index)
                    Box(
                        Modifier.weight(1f).height(40.dp).then(if (date != null) Modifier.monthCalendarDay(date) else Modifier),
                        contentAlignment = Alignment.Center
                    ) {
                        if (date != null) {
                            val isSelected = date == selectedDate
                            Box(
                                modifier = Modifier
                                    .size(36.dp)
                                    .clip(CircleShape)
                                    .background(if (isSelected) DeepNavy else Color.Transparent)
                                    .handCursor()
                                    .clickable { pick(date) },
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    date.day.toString(),
                                    style = MaterialTheme.typography.bodyMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = if (isSelected) Color.White else DeepNavy
                                )
                                if (hasShifts(date)) {
                                    Box(
                                        Modifier
                                            .align(Alignment.BottomCenter)
                                            .padding(bottom = 4.dp)
                                            .size(4.dp)
                                            .clip(CircleShape)
                                            .background(DarkGold)
                                    )
                                }
                            }
                            if (keyboard.ringOn(date)) CalendarFocusRing(42.dp)
                        }
                    }
                }
            }
        }
    }
}

/** SH-136: test tags of the skeleton's wide layout. */
object SkeletonTags {
    /** The empty side beside the timeline's frame (the wheel scrolls the timeline there too). */
    const val TIMELINE_MARGIN = "skeleton_timeline_margin"
}

@Composable
fun RosterBuilderTimeline(
    shifts: List<Shift>,
    /** Null: nothing to delete (read-only). */
    onDeleteShift: ((String) -> Unit)?,
    /** SH-136: hoisted on wide windows, so the empty side beside the frame scrolls it too. */
    scrollState: ScrollState = rememberScrollState()
) {
    val hourHeight = 24.dp
    val startHour = 0

    Box(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(scrollState)
    ) {
        // Grid Lines
        Column {
            for (i in startHour..24) {
                Row(
                    modifier = Modifier
                        .height(hourHeight)
                        .fillMaxWidth(),
                    verticalAlignment = Alignment.Top
                ) {
                    Text(
                        text = if (i < 10) "0$i:00" else "$i:00",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Gray,
                        modifier = Modifier
                            .width(56.dp)
                            .padding(start = 12.dp, top = 4.dp)
                    )
                    Box(
                        modifier = Modifier
                            .weight(1f)
                            .height(1.dp)
                            .padding(top = 10.dp)
                            .background(Color.LightGray.copy(alpha = 0.4f))
                    )
                }
            }
        }

        // Shift blocks with overlap handling
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
                .height((hourHeight * 24))
                .padding(start = 64.dp, end = 16.dp)
        ) {
            val totalWidth = maxWidth
            // Group identical shift templates to show "xN"
            val groupedShifts = shifts.groupBy {
                it.plannedTime.start.substringAfter("T").take(5) +
                        it.plannedTime.end.substringAfter("T").take(5) +
                        it.requiredRole
            }

            val distinctVisuals = groupedShifts.values.map { it.first() to it.size }
                .sortedBy { timeToFloat(it.first.plannedTime.start) }

            val positionedCards = mutableListOf<Triple<Shift, Int, Int>>() // Shift, Count, Lane
            val lanes = mutableListOf<Float>()

            distinctVisuals.forEach { (shift, count) ->
                val start = timeToFloat(shift.plannedTime.start)
                val end = timeToFloat(shift.plannedTime.end)
                val effectiveEnd = if (end < start) 24f else end

                var laneIndex = -1
                for (i in lanes.indices) {
                    if (lanes[i] <= start) {
                        laneIndex = i
                        lanes[i] = effectiveEnd
                        break
                    }
                }
                if (laneIndex == -1) {
                    laneIndex = lanes.size
                    lanes.add(effectiveEnd)
                }
                positionedCards.add(Triple(shift, count, laneIndex))
            }

            val maxLanes = lanes.size.coerceAtLeast(1)
            val cardWidth = totalWidth / maxLanes

            positionedCards.forEach { (shift, count, lane) ->
                val start = timeToFloat(shift.plannedTime.start)
                val end = timeToFloat(shift.plannedTime.end)
                val effectiveEnd = if (end < start) 24f else end

                val topOffset = (start * hourHeight.value).dp
                val height = ((effectiveEnd - start) * hourHeight.value).dp
                val leftOffset = cardWidth * lane

                TimelineShiftCard(
                    role = shift.requiredRole,
                    startTime = shift.plannedTime.start.substringAfter("T").take(5),
                    endTime = shift.plannedTime.end.substringAfter("T").take(5),
                    // SH-190: the exact length, over midnight too (the block stops at midnight).
                    durationMinutes = calculateDurationMinutes(shift.plannedTime.start, shift.plannedTime.end),
                    count = count,
                    modifier = Modifier
                        .offset(x = leftOffset, y = topOffset)
                        .width(cardWidth - 4.dp)
                        .height(height),
                    onDelete = onDeleteShift?.let { delete -> { delete(shift.id) } }
                )
            }
        }
    }
}

@Composable
fun TimelineShiftCard(
    role: String?,
    startTime: String,
    endTime: String,
    durationMinutes: Int,
    count: Int,
    modifier: Modifier = Modifier,
    onDelete: (() -> Unit)?
) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(8.dp))
            .background(Color(0xFFFBF4E9))
            .border(1.dp, DeepNavy, RoundedCornerShape(8.dp))
            .padding(8.dp)
    ) {
        Column {
            if (role != null) {
                Text(
                    text = role,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }

            Text(
                text = ". $startTime - $endTime",
                style = MaterialTheme.typography.labelSmall,
                color = DeepNavy.copy(alpha = 0.8f)
            )
            Text(
                text = ". " + durationText(durationMinutes),
                style = MaterialTheme.typography.labelSmall,
                color = DeepNavy.copy(alpha = 0.8f)
            )
        }

        if (onDelete != null) IconButton(
            onClick = onDelete,
            modifier = Modifier.align(Alignment.TopEnd).size(20.dp)
        ) {
            Icon(
                Icons.Default.Delete,
                null,
                tint = Color.Red.copy(alpha = 0.2f),
                modifier = Modifier.size(14.dp)
            )
        }

        // Circular Badge "xN"
        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .size(52.dp)
                .clip(CircleShape)
                .background(DeepNavy)
                .border(2.dp, DarkGold, CircleShape),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = "x$count",
                color = Color.White,
                fontWeight = FontWeight.Bold,
                fontSize = 20.sp
            )
        }
    }
}

fun timeToFloat(isoString: String): Float {
    return try {
        val timePart = isoString.substringAfter("T").take(5)
        val parts = timePart.split(":")
        val hours = parts[0].toFloat()
        val minutes = parts[1].toFloat()
        hours + (minutes / 60f)
    } catch (e: Exception) {
        0f
    }
}

fun getDaysInMonth(year: Int, month: Int): List<LocalDate> {
    val days = mutableListOf<LocalDate>()
    var current = LocalDate(year, month, 1)
    while (current.month.number == month) {
        days.add(current)
        try {
            current = current.plus(DatePeriod(days = 1))
        } catch (e: Exception) {
            break
        }
    }
    return days
}

@Composable
fun AddShiftFromTemplateDialog(
    templates: List<ShiftTemplate>,
    onDismiss: () -> Unit,
    onSelect: (ShiftTemplate) -> Unit,
    onCustomShift: (startTime: LocalTime, endTime: LocalTime, role: String, saveAsTemplate: Boolean, templateName: String) -> Unit,
    /** The workplace's roles (SH-130): the custom shift's role is picked from them. */
    availableRoles: List<String> = emptyList()
) {
    var isCustomMode by remember { mutableStateOf(templates.isEmpty()) }

    var startTime by remember { mutableStateOf("09:00") }
    var endTime by remember { mutableStateOf("17:00") }
    var role by remember { mutableStateOf("") }
    var saveAsTemplate by remember { mutableStateOf(false) }
    var templateName by remember { mutableStateOf("") }
    var tried by remember { mutableStateOf(false) }

    if (!isCustomMode) {
        EvoDialog(
            title = stringResource(Res.string.roster_add_shift_template),
            icon = Icons.Default.Add,
            onDismiss = onDismiss,
            bodyArrangement = Arrangement.spacedBy(8.dp)
        ) {
            templates.forEach { template ->
                EvoListRow(
                    headline = template.name,
                    supporting = listOfNotNull("${template.startTime} – ${template.endTime}", template.role?.takeIf { it.isNotBlank() })
                        .joinToString(" · "),
                    onClick = { onSelect(template) }
                )
            }
            Spacer(Modifier.height(4.dp))
            EvoSecondaryButton(
                DialogAction(stringResource(Res.string.roster_add_custom_shift), { isCustomMode = true }, icon = Icons.Default.Edit),
                Modifier.fillMaxWidth()
            )
        }
    } else {
        val start = parseClockTime(startTime)
        val end = parseClockTime(endTime)
        val sameTimes = start != null && start == end
        val nameMissing = saveAsTemplate && templateName.isBlank()
        EvoDialog(
            title = stringResource(Res.string.roster_add_custom_shift),
            subtitle = stringResource(Res.string.skeleton_custom_shift_subtitle),
            icon = Icons.Default.Edit,
            onDismiss = onDismiss,
            confirm = DialogAction(
                stringResource(Res.string.save),
                {
                    tried = true
                    if (start != null && end != null && !sameTimes && !nameMissing) {
                        onCustomShift(LocalTime.parse(start), LocalTime.parse(end), role.trim(), saveAsTemplate, templateName.trim())
                    }
                }
            ),
            // Back to the template list when there is one; otherwise this is the whole dialog.
            dismiss = if (templates.isEmpty()) DialogAction(stringResource(Res.string.cancel), onDismiss)
            else DialogAction(stringResource(Res.string.back), { isCustomMode = false })
        ) {
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                EvoTimeField(
                    value = startTime,
                    onValueChange = { startTime = it },
                    label = stringResource(Res.string.roster_start_time),
                    showErrors = tried,
                    modifier = Modifier.weight(1f)
                )
                EvoTimeField(
                    value = endTime,
                    onValueChange = { endTime = it },
                    label = stringResource(Res.string.roster_end_time),
                    placeholder = "17:00",
                    showErrors = tried,
                    error = stringResource(Res.string.time_same_start_end).takeIf { sameTimes },
                    modifier = Modifier.weight(1f)
                )
            }
            RoleField(
                role = role,
                onRoleChange = { role = it },
                availableRoles = availableRoles,
                label = stringResource(Res.string.roster_role_optional),
                optional = true
            )
            EvoCheckboxRow(
                checked = saveAsTemplate,
                onCheckedChange = { saveAsTemplate = it },
                label = stringResource(Res.string.roster_save_as_template)
            )
            AnimatedVisibility(visible = saveAsTemplate) {
                EvoTextField(
                    value = templateName,
                    onValueChange = { templateName = it },
                    label = stringResource(Res.string.template_name),
                    imeAction = ImeAction.Done,
                    error = stringResource(Res.string.skeleton_template_name_required).takeIf { tried && nameMissing }
                )
            }
        }
    }
}

@Composable
fun SelectDayTemplateDialog(
    templates: List<DayTemplate>,
    onDismiss: () -> Unit,
    onSelect: (DayTemplate) -> Unit
) {
    EvoDialog(
        title = stringResource(Res.string.roster_apply_day_template),
        icon = Icons.Default.ViewDay,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(8.dp)
    ) {
        if (templates.isEmpty()) {
            Text(
                stringResource(Res.string.roster_no_day_templates),
                color = Color.White.copy(alpha = 0.7f)
            )
        }
        templates.forEach { template ->
            EvoListRow(
                headline = template.name,
                supporting = stringResource(Res.string.template_shift_count, template.shiftTemplateIds.size),
                onClick = { onSelect(template) }
            )
        }
    }
}

/**
 * The sales plan of the month whose skeleton was just finished (SH-69): the total, how many days
 * have a target, and the targets per weekday. Continuing leads to the availability request.
 */
@Composable
fun RevenuePlanDialog(
    plan: RevenuePlan,
    currency: String,
    monthLabel: String,
    onContinue: () -> Unit
) {
    EvoDialog(
        title = stringResource(Res.string.skeleton_done_revenue_title),
        subtitle = monthLabel,
        icon = Icons.Default.Check,
        onDismiss = onContinue,
        dismissOnClickOutside = false,
        confirm = DialogAction(stringResource(Res.string.skeleton_done_continue), onContinue),
        dismiss = null
    ) {
        Text(
            stringResource(Res.string.skeleton_done_revenue_intro),
            style = MaterialTheme.typography.bodyMedium,
            color = Color.White.copy(alpha = 0.8f)
        )
        if (plan.total <= 0.0) {
            Text(
                stringResource(Res.string.skeleton_done_revenue_none),
                style = MaterialTheme.typography.bodyMedium,
                color = DarkGold
            )
            return@EvoDialog
        }
        Column {
            Text(
                stringResource(Res.string.skeleton_done_revenue_total),
                style = MaterialTheme.typography.labelMedium,
                color = Color.White.copy(alpha = 0.6f)
            )
            Text(
                formatMoney(plan.total, currency),
                style = MaterialTheme.typography.headlineSmall,
                fontWeight = FontWeight.Bold,
                color = DarkGold
            )
            Text(
                stringResource(Res.string.skeleton_done_revenue_days, plan.daysWithTarget, plan.days.size),
                style = MaterialTheme.typography.bodySmall,
                color = Color.White.copy(alpha = 0.7f)
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
            plan.byWeekday.forEach { weekday ->
                RevenuePlanRow(
                    label = stringResource(Res.string.skeleton_done_revenue_weekday, dayShort(weekday.dayOfWeek), weekday.days),
                    amount = formatMoney(weekday.total, currency)
                )
            }
            if (plan.fixedRevenueMonthly > 0.0) {
                RevenuePlanRow(stringResource(Res.string.skeleton_done_revenue_fixed), formatMoney(plan.fixedRevenueMonthly, currency))
            }
        }
    }
}

@Composable
private fun RevenuePlanRow(label: String, amount: String) {
    Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
        Text(label, style = MaterialTheme.typography.bodyMedium, color = Color.White, modifier = Modifier.weight(1f))
        Text(amount, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = Color.White)
    }
}

